/**
 * Utilidades compartidas del kiosco.
 * `cn` es la funcion que espera shadcn/ui para componer clases de Tailwind.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Une clases de Tailwind resolviendo conflictos (la ultima gana). */
export function cn(...entradas: ClassValue[]): string {
  return twMerge(clsx(entradas));
}

/** Formatea un importe en euros, formato espanol, con signo explicito. */
export function formatearEuros(importe: number, conSigno = false): string {
  const texto = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(importe));
  if (!conSigno) return importe < 0 ? `-${texto}` : texto;
  return `${importe < 0 ? '−' : '+'}${texto}`;
}

/** Formatea una fecha ISO (AAAA-MM-DD) como '28 de julio'. */
export function formatearFechaLarga(iso: string): string {
  const fecha = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(fecha.getTime())) return iso;
  return new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long' }).format(fecha);
}

/** Formatea una marca de tiempo ISO como 'HH:MM'. */
export function formatearHora(iso: string): string {
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return '';
  return new Intl.DateTimeFormat('es-ES', { hour: '2-digit', minute: '2-digit' }).format(fecha);
}

/** Espera `ms` milisegundos (util para reintentos con backoff). */
export function esperar(ms: number): Promise<void> {
  return new Promise((resolver) => setTimeout(resolver, ms));
}
